module.exports = __webpack_public_path__ + "static/media/Logo.329467c9.png";